"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
// import { materialColors } from '../../themes/main/colors'
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            width: 32,
            height: 20,
            padding: 0,
            // normal track
            '& .MuiSwitch-colorPrimary + .MuiSwitch-track': {
                backgroundColor: theme.palette.grey[50],
            },
            // checked track
            '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
            },
            // disabled track
            '& .MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track': {
                backgroundColor: theme.palette.action.disabledBackground,
                opacity: 1,
            },
            // disabled and checked track
            '& .MuiSwitch-colorPrimary.Mui-disabled.Mui-checked + .MuiSwitch-track': {
                backgroundColor: theme.palette.action.disabledBackground,
            },
            // disabled thumb
            '& .MuiSwitch-colorPrimary.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[200],
            },
        },
        switchBase: {
            padding: 1,
            '&$checked': {
                transform: 'translateX(12px)',
                color: theme.palette.common.white,
                '& + $track': {
                    opacity: 1,
                },
            },
            '&$checked :not(.Mui-disabled)': {
                '& + $track': {
                    opacity: 1,
                    border: 'none',
                    backgroundColor: theme.palette.primary.main,
                },
            },
            '&$focusVisible $thumb': {
                color: theme.palette.primary.main,
                border: '6px solid #fff',
            },
        },
        thumb: {
            width: 18,
            height: 18,
            color: theme.palette.common.white,
        },
        track: {
            borderRadius: 26 / 2,
            border: "1px solid ".concat(theme.palette.grey[400]),
            opacity: 1,
            transition: theme.transitions.create(['background-color', 'border']),
        },
        checked: {},
        focusVisible: {},
        cell: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        label: {
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            '& .MuiFormControlLabel-label': {
                fontWeight: 'inherit',
                fontSize: 'inherit',
                lineHeight: 'inherit',
            },
        },
    });
});
